"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callStylableBuild = exports.generateSantaCSS = exports.initStylableCompilerWithMetadata = exports.getStylableCompilerWithMetadata = void 0;
var core_1 = require("@stylable/core");
var fonts_1 = __importDefault(require("@wix/santa-core-utils/dist/fonts"));
var injections_1 = require("./utils/injections");
var directives_1 = require("./utils/directives");
var object_sizeof_1 = __importDefault(require("object-sizeof"));
var consts_1 = require("./consts");
var inline_modules_1 = require("./inline-modules/inline-modules");
var fonts_stylable_1 = require("./fonts/fonts-stylable");
var font_utils_1 = require("./fonts/font-utils");
var context_1 = require("./inline-modules/context");
var santa_utils_1 = require("./santa-utils");
var dynamic_lib_loader_1 = require("./dynamic-lib-loader");
var wrap_metrics_reporter_1 = require("./wrap-metrics-reporter");
var map_1 = require("./map");
var internal_1 = require("./utils/internal");
var getUploadedFontFaceStyles = fonts_1.default.getUploadedFontFaceStyles;
var stylableInstances = new Map();
/* init stylable fs - using metadata fs, and process each file once */
function getStylableCompilerWithMetadata(_a) {
    var metadata = _a.metadata;
    var stylableInstance = stylableInstances.get(metadata);
    if (!stylableInstance) {
        stylableInstance = initStylableCompilerWithMetadata({ metadata: metadata });
        stylableInstances.set(metadata, stylableInstance);
    }
    return stylableInstance;
}
exports.getStylableCompilerWithMetadata = getStylableCompilerWithMetadata;
function generateResponse(css, fonts, options) {
    var isMasterPage = options.isMasterPage, mediaRootUrl = options.mediaRootUrl, returnCompletePojo = options.returnCompletePojo, libCSS = options.libCSS, returnSeparatedCss = options.returnSeparatedCss, separatedCssAsString = options.separatedCssAsString;
    // Add lib css if required
    var libCssIfNeeded = isMasterPage ? libCSS : '';
    var uploadedFontFaceStyles = getUploadedFontFaceStyles(fonts, mediaRootUrl);
    var fontsPart = uploadedFontFaceStyles.length > 0 ? consts_1.CSS_HEADER_UPLOADED_FONTS + uploadedFontFaceStyles : '';
    var outputCss;
    if (returnSeparatedCss && returnCompletePojo) {
        if (separatedCssAsString) {
            Object.keys(css).forEach(function (key) {
                css[key] = css[key].toString();
            });
        }
        outputCss = {
            global: libCssIfNeeded + fontsPart,
            styles: css
        };
        return {
            css: outputCss,
            fonts: fonts
        };
    }
    else {
        var cssPart = css ? consts_1.CSS_HEADER_SITE_CSS + css : '';
        outputCss = libCssIfNeeded + cssPart + fontsPart;
    }
    if (returnCompletePojo) {
        return {
            css: outputCss,
            fonts: fonts,
        };
    }
    else {
        return outputCss;
    }
}
function calculateObjectSize(obj) {
    return object_sizeof_1.default(obj);
}
function unique(a) {
    return Array.from(new Set(a));
}
function parseBoolean(value) {
    if (value === 'true') {
        return true;
    }
    return false;
}
function getPlainCss(parsedCompDataArray, options, stylable) {
    // Process and transform css from page
    var uriToLayoutMapping = {};
    // Process ast and extract uri->layout mapping
    var metaMap = parsedCompDataArray.reduce(function (accum, item) {
        var meta = core_1.process(item.ast, undefined, function () { return item.refArrayId || item.styleId; });
        context_1.collectUriToLayoutMapping(meta, uriToLayoutMapping, item.compLayout);
        accum[internal_1.createRobustKey(item.styleId, item.refArrayId)] = meta;
        return accum;
    }, {});
    // Update layout mapping:
    context_1.inlineModulesContext.setStaticMediaUrl(options.staticMediaUrl);
    context_1.inlineModulesContext.setUseWebp(options.mediaAsWebp);
    context_1.inlineModulesContext.setUriToLayoutMap(uriToLayoutMapping);
    // Set font themes:
    context_1.inlineModulesContext.setFontThemes(getThemeData(options));
    // Transform:
    var transformedObject = {};
    Object.keys(metaMap).forEach(function (key) {
        var meta = metaMap[key];
        var stylableResults = stylable.createTransformer().transform(meta);
        var ast = stylableResults.meta.outputAst;
        transformedObject[key] = ast;
    });
    return transformedObject;
}
function getThemeData(options) {
    return options.masterJson.data.theme_data[consts_1.THEME_DATA];
}
function getUsedFonts(parsedCompDataArray, options) {
    var fontThemeClassNames = font_utils_1.getFontThemeClassNames(getThemeData(options));
    var fontsFilter = function (decl) {
        return fontThemeClassNames.indexOf(decl.parent.selector) === -1;
    };
    var fonts = parsedCompDataArray.reduce(function (acc, item) {
        return acc.concat(fonts_stylable_1.findFontsInAst(item.ast, fontsFilter));
    }, []);
    return unique(fonts);
}
function preParse(item, injection) {
    var fixedContent = injection + '\n' + item.content;
    var ast = core_1.safeParse(fixedContent, { from: item.styleId });
    return __assign(__assign({}, item), { ast: ast });
}
function processStylableCss(cssData, options, injection, stylable) {
    var metricsReporter = options.metricsReporter;
    // Generate plain css from each style
    var parsedCompDataArray = metricsReporter.runAndReport(function () { return map_1.map(cssData, function (item) { return preParse(item, injection); }); }, consts_1.METERING_PRE_PARSE);
    var fonts = metricsReporter.runAndReport(function () { return getUsedFonts(parsedCompDataArray, options); }, consts_1.METERING_COLLECT_FONTS);
    var css = metricsReporter.runAndReport(function () { return getPlainCss(parsedCompDataArray, options, stylable); }, consts_1.METERING_TRANSFORM);
    if (!options.returnSeparatedCss) {
        // Turn map of css to one giant css string:
        css = Object.values(css).map(function (ast) { return ast.toString(); }).join('\n');
    }
    var response = generateResponse(css, fonts, options);
    metricsReporter.histogram("" + consts_1.METERING_HIST_RESPONSE_SIZE + (options.isMasterPage ? consts_1.METERING_HIST_RESPONSE_SIZE_MASTER_SUFFIX : ''), calculateObjectSize(response));
    return response;
}
function getCSSHeaderInjection(_a) {
    var themeData = _a.themeData, isMobileView = _a.isMobileView;
    var variableInjection = injections_1.generateStylableThemeVars(themeData);
    var mobileVariableInjection = injections_1.generateStylableBreakpoints(isMobileView);
    return [variableInjection, mobileVariableInjection, directives_1.jsModulesImport, directives_1.fontThemesImport].join('\n');
}
function wrapHttpsIfNeeded(url, addTrailingSlash) {
    if (addTrailingSlash === void 0) { addTrailingSlash = false; }
    var retval = url;
    if (retval === undefined) {
        return '';
    }
    if (addTrailingSlash && !retval.endsWith('/')) {
        retval = retval + "/";
    }
    if (url.startsWith('http://')) {
        return url.replace('http://', 'https://');
    }
    if (!url.startsWith('https://')) {
        retval = "https://" + retval;
    }
    return retval;
}
function initStylableCompilerWithMetadata(_a) {
    var metadata = _a.metadata;
    var _b = core_1.createMinimalFS({
        files: metadata.fs,
    }), fs = _b.fs, requireModule = _b.requireModule;
    var resolveOptions = { alias: metadata.packages, symlinks: false };
    var defaultResolver = core_1.createDefaultResolver(fs, resolveOptions);
    var resolveModule = function (directoryPath, request) {
        return inline_modules_1.inlineModules[request] ? request : defaultResolver(directoryPath, request);
    };
    var stylable = core_1.Stylable.create({
        fileSystem: fs,
        projectRoot: '/',
        requireModule: inline_modules_1.wrapRequireWithInlineModules(requireModule, inline_modules_1.inlineModules),
        mode: 'production',
        resolveOptions: resolveOptions,
        resolveModule: resolveModule,
        cssParser: core_1.safeParse,
    });
    // Process metadata files
    Object.keys(metadata.fs).forEach(function (filePath) {
        var meta = stylable.process(filePath);
        meta.namespace = metadata.fs[filePath].metadata.namespace || meta.namespace;
    });
    return stylable;
}
exports.initStylableCompilerWithMetadata = initStylableCompilerWithMetadata;
function generateSantaCSS(options, stylable) {
    if (!options.masterJson) {
        throw new Error('no masterJson');
    }
    if (!options.masterJson.data.theme_data[consts_1.THEME_DATA]) {
        // TODO no need for this shit
        throw new Error('no theme data');
    }
    if (options.returnSeparatedCss && !options.returnCompletePojo) {
        throw new Error('generateSantaCSS: returnSeparatedCss is only supported when returnCompletePojo (getAnnotatedStyle) is enabled');
    }
    // normalize topology
    options.staticMediaUrl = wrapHttpsIfNeeded(options.staticMediaUrl);
    options.mediaRootUrl = wrapHttpsIfNeeded(options.mediaRootUrl, true);
    var stylableCssSiteData = new Map();
    // Gather stylable st-css data from page
    if (options.pageJson) {
        santa_utils_1.extractCssDataFromPage(options.logger, options.pageJson, stylableCssSiteData, options.isMobileView, options.masterJson);
    }
    santa_utils_1.extractCssDataFromPage(options.logger, options.masterJson, stylableCssSiteData, options.isMobileView, undefined);
    return processStylableCss(stylableCssSiteData, options, getCSSHeaderInjection({
        themeData: getThemeData(options),
        isMobileView: !!options.isMobileView,
    }), stylable);
}
exports.generateSantaCSS = generateSantaCSS;
function callStylableBuild(pages, params, metricsReporter, moduleFetcher, topology, logger) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // const experimentMap = getExperimentsMap(params.stExp);
                    // add relevant experiment data to metrics reporting name
                    metricsReporter = wrap_metrics_reporter_1.wrapMetricsReporter(metricsReporter, function (name) { return name + (params.stExp ? '_' + params.stExp : ''); });
                    return [4 /*yield*/, metricsReporter.runAsyncAndReport(function () { return __awaiter(_this, void 0, void 0, function () {
                            var _a, pageJson, masterPage, isMasterPage, _b, libCSS, stylable;
                            var _this = this;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0: return [4 /*yield*/, metricsReporter.runAsyncAndReport(function () { return __awaiter(_this, void 0, void 0, function () {
                                            var mp, isMp, mpDummy, onlyPage, pageId, pj;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, pages.masterPage];
                                                    case 1:
                                                        mp = _a.sent();
                                                        isMp = Object.keys(pages).length === 1;
                                                        mpDummy = pages.masterPage, onlyPage = __rest(pages, ["masterPage"]);
                                                        pageId = Object.keys(onlyPage)[0];
                                                        return [4 /*yield*/, pages[pageId]];
                                                    case 2:
                                                        pj = _a.sent();
                                                        return [2 /*return*/, { pageJson: pj, masterPage: mp, isMasterPage: isMp }];
                                                }
                                            });
                                        }); }, consts_1.METERING_FETCH)];
                                    case 1:
                                        _a = _c.sent(), pageJson = _a.pageJson, masterPage = _a.masterPage, isMasterPage = _a.isMasterPage;
                                        return [4 /*yield*/, initStylable(params.libVer, function (fromUrl) { return moduleFetcher.fetch({ fromUrl: fromUrl }); }, metricsReporter, topology)];
                                    case 2:
                                        _b = _c.sent(), libCSS = _b.libCSS, stylable = _b.stylable;
                                        return [2 /*return*/, generateSantaCSS({
                                                masterJson: masterPage,
                                                pageJson: pageJson,
                                                isMasterPage: isMasterPage,
                                                libCSS: libCSS,
                                                isMobileView: parseBoolean(params.isMobileView),
                                                metricsReporter: metricsReporter,
                                                returnCompletePojo: parseBoolean(params.getAnnotatedStyle),
                                                mediaRootUrl: topology.mediaRootUrl,
                                                staticMediaUrl: topology.staticMediaUrl,
                                                mediaAsWebp: parseBoolean(params.mediaAsWebp),
                                                returnSeparatedCss: parseBoolean(params.returnSeparatedCss),
                                                separatedCssAsString: true,
                                                logger: logger
                                            }, stylable)];
                                }
                            });
                        }); }, consts_1.METERING_TOTAL)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.callStylableBuild = callStylableBuild;
function initStylable(libVer, loadModule, metricsReporter, topology) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, libCSS, metadata;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (typeof libVer !== 'string') {
                        throw new Error('Missing libVer param');
                    }
                    return [4 /*yield*/, metricsReporter.runAsyncAndReport(function () { return dynamic_lib_loader_1.fetchMetadataAndLibCSS(libVer, loadModule, topology.moduleRepoUrl); }, 'fetch-metadata')];
                case 1:
                    _a = _b.sent(), libCSS = _a.libCSS, metadata = _a.metadata;
                    return [2 /*return*/, {
                            libCSS: libCSS,
                            stylable: getStylableCompilerWithMetadata({ metadata: metadata }),
                        }];
            }
        });
    });
}
//# sourceMappingURL=stylable-santa-server-funcs.js.map